import { ObjectUtils } from "../../utils/ObjectUtils";

export class OrgaoJulgador {
    static novo(partial: Partial<OrgaoJulgador>): OrgaoJulgador {
        return ObjectUtils.assign(new OrgaoJulgador(), partial);
    }

    sigla: string = undefined;
    descricao: string = undefined;
}